export const STABLE_DELTA_THRESHOLD = 0.05;
export const SPARKLINE_MIN_DAYS = 12;
export const SPARKLINE_MAX_DAYS = 30;

const DELTA_NUMBER = new Intl.NumberFormat("fr-CA", { minimumFractionDigits: 1, maximumFractionDigits: 1 });
const finite = (value) => value !== null && value !== undefined && value !== "" && Number.isFinite(Number(value));

// Percent indicators move in points, amounts in percent of the previous value; null hides the comparison.
export function resolveMetricDelta(current, previous, { unit = "%", higherIsBetter = true } = {}) {
  if (!finite(current) || !finite(previous)) return null;
  const raw = unit === "pts" ? Number(current) - Number(previous)
    : Number(previous) !== 0 ? (Number(current) - Number(previous)) / Math.abs(Number(previous)) * 100 : null;
  if (raw === null || !Number.isFinite(raw)) return null;
  const value = Math.round(raw * 10) / 10;
  if (Math.abs(value) < STABLE_DELTA_THRESHOLD) return { value: 0, label: "= stable", tone: "flat" };
  const tone = higherIsBetter === null ? "flat" : (value > 0) === higherIsBetter ? "good" : "bad";
  return { value, label: `${value > 0 ? "▲ +" : "▼ −"}${DELTA_NUMBER.format(Math.abs(value))} ${unit === "pts" ? "pts" : "%"}`, tone };
}

export function resolveComparisonLabel(period, previousDispatchCount) {
  if (period?.key === "day") return "vs veille";
  if (period?.key === "week" && period.shortLabel === "Semaine") return "vs semaine précédente";
  const count = Math.max(Number(previousDispatchCount) || 0, 0);
  return `vs ${count} précédent${count > 1 ? "s" : ""}`;
}

// Bars of the last 12 to 30 dispatchs, scaled 25-100 %; the selected period is drawn darker than its context.
export function buildSparkline(days = [], valueOf, selectedDates = new Set(), barCount = SPARKLINE_MIN_DAYS) {
  const count = Math.min(Math.max(barCount, SPARKLINE_MIN_DAYS), SPARKLINE_MAX_DAYS);
  const bars = days.slice(-count).map((day) => ({ date: day.dispatchDate, value: finite(valueOf(day)) ? Number(valueOf(day)) : null }));
  const values = bars.map((bar) => bar.value).filter((value) => value !== null);
  const minimum = Math.min(...values);
  const maximum = Math.max(...values);
  return bars.map((bar) => ({
    ...bar,
    heightPct: bar.value === null ? 0 : maximum > minimum ? 25 + 75 * (bar.value - minimum) / (maximum - minimum) : 100,
    selected: selectedDates.has(bar.date),
  }));
}
